exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  margin-top: 10px; }\n  .container .headerStyle {\n    text-align: center;\n    padding-bottom: 10px;\n    padding-top: 10px;\n    font-size: 20px;\n    background: MD_DIALOG_DATA;\n    color: white;\n    border-radius: 4px; }\n  .container .entryFields .row {\n    text-align: center; }\n  .container .formStyle {\n    border: 1px solid #e4e6e5;\n    border-radius: 4px; }\n\n/deep/ .mat-menu-panel.test {\n  background-color: #b7b7b7;\n  width: 160px;\n  text-align: left;\n  color: #fff; }\n  /deep/ .mat-menu-panel.test a {\n    display: block;\n    padding: 9px 10px;\n    margin: 0;\n    border-bottom: 1px solid #999; }\n\n/deep/ .mat-menu-panel.test_1 {\n  background-color: #b7b7b7;\n  width: 160px;\n  text-align: left;\n  color: #fff;\n  margin-top: 48px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/device-entry/device-entry.component.scss
// module id = ../../../../../src/app/device-entry/device-entry.component.scss
// module chunks = main